import { render } from "./PurchaseRentDiscount.vue?vue&type=template&id=5e783bea"
import script from "./PurchaseRentDiscount.vue?vue&type=script&lang=js"
export * from "./PurchaseRentDiscount.vue?vue&type=script&lang=js"

import "./PurchaseRentDiscount.vue?vue&type=style&index=0&id=5e783bea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__